import React from 'react'

export const ArrowLeftIcon = ({ color = '#AC0AE8', ...props }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.7925 6.23215C11.0785 6.53177 11.0675 7.00651 10.7679 7.29252L5.83621 12L10.7679 16.7075C11.0675 16.9935 11.0785 17.4682 10.7925 17.7679C10.5065 18.0675 10.0318 18.0785 9.73214 17.7925L4.23214 12.5425C4.08388 12.401 4 12.205 4 12C4 11.795 4.08388 11.599 4.23214 11.4575L9.73214 6.20749C10.0318 5.92148 10.5065 5.93252 10.7925 6.23215Z'
        fill={color}
      />
      <path d='M19.25 12L5 12L19.25 12Z' fill={color} />
      <path
        d='M19.25 12L5 12'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
